import store from '@/store'
export default [
  {
    path: '/payment-adjustments',
    name: 'payment-adjustment',
    meta: { requiresAuth: true },
    component: () => import('@/pages/payment-adjustment/index.vue')
  }
]
